/**
 * GitHub username parsing/validation.
 * Shared between the server and the browser bundle, so it must stay dependency free.
 */

// 1-39 chars, alphanumeric or single hyphens, cannot start or end with a hyphen.
const USERNAME_PATTERN = /^[a-z\d](?:[a-z\d]|-(?=[a-z\d])){0,38}$/i;

export type UsernameParseResult =
    | { ok: true; username: string }
    | { ok: false; reason: 'empty' | 'invalid' };

/**
 * Accepts `octocat`, `@octocat`, `github.com/octocat`, `https://github.com/octocat/`
 * (and similar) and extracts the username.
 */
export const parseUsername = (input: unknown): UsernameParseResult => {
    let value = typeof input === 'string' ? input.trim() : '';
    if (!value) return { ok: false, reason: 'empty' };

    value = value
        .replace(/^https?:\/\//i, '')
        .replace(/^(www\.)?github\.com\//i, '')
        .replace(/^@/, '')
        .replace(/[?#].*$/, '')
        .replace(/\/+$/, '');

    // `github.com/octocat/repo` -> `octocat`
    const [candidate] = value.split('/');
    if (!candidate) return { ok: false, reason: 'empty' };

    return USERNAME_PATTERN.test(candidate)
        ? { ok: true, username: candidate }
        : { ok: false, reason: 'invalid' };
};

export const isValidUsername = (username: string): boolean => USERNAME_PATTERN.test(username);
